import React from "react";

import { withSentryTracing } from "supercell-frontend-base/src/tracing/sentry";
import { SnowplowContextProvider } from "supercell-frontend-base/src/analytics/snowplow";
import { AppController } from "./controller";

import {
    BrawlStarsGameParams,
    BrawlStarsGameParamsSchema,
} from "../../validation/game-params";
import {
    GameParamsContextProvider,
    DEFAULT_STATE,
} from "supercell-frontend-base/src/stores/gameParams";

const WithGameParams = (props: any) => {
    return (
        <SnowplowContextProvider
            config={{
                appId: (window as any).SNOWPLOW_APP_ID,
                collectorUrl: (window as any).SNOWPLOW_COLLECTOR_URL,
            }}
        >
            <GameParamsContextProvider<BrawlStarsGameParams>
                initialState={DEFAULT_STATE}
                gameParamsParser={BrawlStarsGameParamsSchema}
            >
                <AppController {...props} />
            </GameParamsContextProvider>
        </SnowplowContextProvider>
    );
};

export const App = withSentryTracing(WithGameParams);
